export const IDLE = 'idle'
export const FETCHING = 'fetching'
export const LOADING = 'loading'
export const SENDING = 'sending'
export const ERROR = 'error'
